<template>
  <!-- 密码：09876 -->
  <div>
    <el-card style="margin-bottom:10px"
             shadow="nerver">
      <div class="filter-area">
        <!-- 目的地 -->
        <div>
          <select-dest placeholder="所属目的地"
                       @selectDest="selectDest"></select-dest>
        </div>
        <!-- 行程状态 -->
        <div class="trip_attritube_style">
          <el-radio-group v-model="trip_type"
                          size="mini">
            <el-radio-button label="2">整日</el-radio-button>
            <el-radio-button label="1">抵达</el-radio-button>
            <el-radio-button label="3">离开</el-radio-button>
            <el-radio-button label="4">中转</el-radio-button>
          </el-radio-group>
        </div>
        <!-- 旅行方式 -->
        <div class="trip_attritube_style">
          <el-radio-group v-model="trip_mode"
                          size="mini">
            <el-radio-button label="1">探索模式</el-radio-button>
            <el-radio-button label="2">自驾/租车</el-radio-button>
            <el-radio-button label="3">拼团</el-radio-button>
          </el-radio-group>
        </div>
        <!-- 搜索 -->
        <el-input size="mini"
                  style="width:20%;margin-left:20px"
                  placeholder="请输入迹点"
                  v-model="searchContentKeyword"
                  clearable>
          <el-button slot="append"
                     @click="searchButton"
                     icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <!-- 标签 -->
      <div class="filter-area-tag">
        <select-tag :showTitle="true"
                    :creatNewTag="false"
                    :tagList="contentTags"
                    @getSelectList="getSelectList"></select-tag>
      </div>
    </el-card>
    <!-- ---------------------------内容列表--------------------------- -->
    <el-card shadow="nerver"
             :style="bodyStyle"
             v-loading="loading">
      <!-- 新建 -->
      <div style="margin-bottom:10px">
        <el-button @click="creatNewTraverContent"
                   size="mini"
                   type="primary">新建日行程</el-button>
      </div>

      <!-- 列表 -->
      <div>
        <el-table :data="dayTripData"
                  :header-cell-style="courseRowClass"
                  style="width: 100%">
          <el-table-column prop="trip_id"
                           label="行程ID"
                           align="center"
                           width="70">
          </el-table-column>
          <el-table-column prop="dest"
                           label="目的地"
                           align="center"
                           width="70">
            <template slot-scope="item">
              <el-popover placement="top"
                          width="150"
                          trigger="hover">
                <div style=" position: relative;">
                  <show-qr-code :size="150"
                                :showTitle="true"
                                :marginSize="0"
                                :code="item.row.trip_id"
                                :introduce="'扫码查看日行程【'+item.row.trip_id+'】'"
                                type="dayTripReview"></show-qr-code>
                </div>
                <div slot="reference">
                  {{item.row.dest}}</div>
              </el-popover>

            </template>
          </el-table-column>
          <el-table-column prop="date"
                           label="行程状态"
                           align="center"
                           width="80">
            <template slot-scope="item">
              <!-- 方式标签 -->
              <div size="mini"
                   style="color:#ff5421"
                   v-if="item.row.trip_type=='2'">整日</div>
              <div size="mini"
                   style="color:#163AF3"
                   v-else-if="item.row.trip_type=='1'">抵达</div>
              <div size="mini"
                   style="color:green"
                   v-else-if="item.row.trip_type=='3'">离开
              </div>
              <div size="mini"
                   style="color:#FFC300"
                   v-else-if="item.row.trip_type=='4'">中转
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="date"
                           label="旅行模式"
                           align="center"
                           width="90">
            <template slot-scope="item">
              <!-- 方式标签 -->
              <el-tag size="mini"
                      v-if="item.row.trip_mode=='1'">探索</el-tag>
              <el-tag size="mini"
                      v-else-if="item.row.trip_mode=='2'">自驾/包车</el-tag>
              <el-tag size="mini"
                      v-else-if="item.row.trip_mode=='3'">拼团
              </el-tag>
            </template>

          </el-table-column>
          <el-table-column prop="recommend_time"
                           width="80"
                           label="建议出发">
          </el-table-column>
          <el-table-column show-overflow-tooltip
                           label="日行程包含">
            <template slot-scope="item">

              <!-- 有行程说明 -->
              <div v-if="item.row.remark">
                <el-popover placement="top-start"
                            width="auto"
                            trigger="hover">
                  <!-- 日行程说明 -->
                  <div style="font-size:6px">行程说明：{{item.row.remark}}</div>
                  <!-- 日行程概况 -->
                  <div style="color:#ff5421"
                       slot="reference">
                    <span v-for="traver,index in item.row.traver_list"
                          :key="index">{{traver.name}}
                      <span v-show="item.row.traver_list.indexOf(traver)!==item.row.traver_list.length-1"> -> </span>
                    </span>
                  </div>
                </el-popover>
              </div>
              <!-- 没有行程说明 -->
              <div v-else>
                <div style="color:#ff5421">
                  <span v-for="traver,index in item.row.traver_list"
                        :key="index">{{traver.name}}
                    <span v-show="item.row.traver_list.indexOf(traver)!==item.row.traver_list.length-1"> -> </span>
                  </span>
                </div>
              </div>
              <!-- 可选营业日期 -->
              <div class="weekend-style-day-trip">
                可选星期：
                <span style="margin-left:5px"
                      v-for="i,index in item.row.running_week"
                      :key="index">
                  <span v-if="i=='1'">星期一</span>
                  <span v-else-if="i=='2'">星期二</span>
                  <span v-else-if="i=='3'">星期三</span>
                  <span v-else-if="i=='4'">星期四</span>
                  <span v-else-if="i=='5'">星期五</span>
                  <span v-else-if="i=='6'">星期六</span>
                  <span v-else-if="i=='0'">星期日</span>
                </span>
              </div>

            </template>
          </el-table-column>
          <el-table-column width="120"
                           align="center"
                           label="操作">
            <template slot-scope="item">
              <el-button-group>
                <el-button type="primary"
                           size="mini"
                           icon="el-icon-edit"
                           @click="editorDayTrip(item.row.trip_id)"
                           circle></el-button>
                <el-button type="success"
                           size="mini"
                           icon="el-icon-view"
                           circle></el-button>
                <!-- 二维码 -->

                <!-- <show-qr-code :size="50"
                              :showTitle="false"
                              :marginSize="0"
                              :code="item.row.id"
                              type="traverReview"></show-qr-code> -->

              </el-button-group>

              <!-- 删除 -->
              <el-popover placement="top"
                          @hide="hideInputPassword"
                          v-model="item.row.visible"
                          width="160">
                <p>删除日行程需要验证：</p>
                <div style="text-align: right; margin: 0">
                  <el-input style="margin:5px 0"
                            autocomplete="off"
                            v-model="showPasswordDelete"
                            size="mini"></el-input>
                  <el-button size="mini"
                             type="text"
                             @click="item.row.visible = false">取消</el-button>
                  <el-button type="primary"
                             size="mini"
                             @click="deleteDayTrip(item.row)">删除</el-button>
                </div>
                <el-button type="primary"
                           slot="reference"
                           size="mini"
                           icon="el-icon-delete"
                           circle></el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- ----------------- 分页 ------------------ -->
      <div class="pagination">
        <el-pagination @current-change="handleCurrentChange_system"
                       :small="true"
                       background
                       layout="prev, pager, next,total"
                       :current-page.sync="pagenum_system"
                       :page-size="pagesize"
                       :total="page_account"></el-pagination>
      </div>

    </el-card>
    <!-- ---------------------------内容列表【结束】--------------------------- -->

    <!-- 对话框 -->

  </div>
</template>

<script>
import showQRcode from '../../components/common/other/hoverShowQRcode.vue'

import SelectDest from '../../components/common/select/SelectDest'
import SelectTag from '../../components/common/select/SelectTag'
let clientHeight = document.documentElement.clientHeight
let contentHeight = clientHeight - 150
export default {
  name: 'day_trip_list',
  components: {
    'select-dest': SelectDest,
    'select-tag': SelectTag,
    'show-qr-code': showQRcode,
  },
  data() {
    return {
      loading: false,
      bodyStyle: `min-height: ${contentHeight}px`,
      day_trip_list: [],
      searchContentKeyword: '',
      dest: '',
      traver_id: '',
      trip_type: '',
      trip_mode: '',
      contentTags: [], // 标签内容
      tag_list: [], // 选择的标签
      // 分页
      pagenum_system: 1, // 当前页
      pagesize: 10, // 每页容量，自行设定
      page_account: null,
      // 日行程列表
      dayTripData: [],
      showPasswordDelete: '',
    }
  },
  computed: {},
  mounted() {
    this.getAllContentTag()
    this.getDayTripList()
  },
  methods: {
    // 隐藏密码框--删除日行程
    hideInputPassword() {
      this.showPasswordDelete = ''
    },
    // 删除日行程
    deleteDayTrip(val) {
      let pass = '09876'
      if (this.passwordDelete == '') {
        this.$message({
          message: '请输入密码验证权限',
          type: 'error',
        })
      } else {
        if (this.showPasswordDelete == pass) {
          // 执行删除
          this.$http
            .get(`/traver/delete_day_trip?trip_id=${val.trip_id}`)
            .then((res) => {
              if (res.data.errno == '0') {
                this.$message({
                  message: res.data.errmsg,
                  type: 'success',
                })
                this.getDayTripList()
              } else {
                this.$message({
                  message: res.data.errmsg,
                  type: 'error',
                })
              }
            })
        } else {
          this.$message({
            message: '验证不通过',
            type: 'error',
          })
        }
      }
    },
    // 分页
    handleCurrentChange_system(page_num) {
      this.pagenum_system = page_num
      this.getDayTripList()
    },
    // 编辑日行程
    editorDayTrip(val) {
      // console.log(val)
      const newpage = this.$router.resolve({
        name: 'update_day_trip',
        query: { id: val },
      })
      window.open(newpage.href, '_blank')
    },
    // 表头的样式
    courseRowClass() {
      return 'background-color:whitesmoke; '
    },
    // 选择目的地
    selectDest(value) {
      if (value !== null) {
        this.dest = value
      } else {
        this.dest = ''
      }
    },
    // 选择标签
    getSelectList(value) {
      let selectList = []
      value.forEach((i) => {
        selectList.push(i.tag_id)
      })
      this.tag_list = selectList
    },
    searchButton() {
      this.getDayTripList()
    },
    // 编辑内容
    clickButtonEditor(value) {},
    // 获取所有内容标签
    getAllContentTag() {
      this.$http.get('/traver/get_content_tag').then((res) => {
        const { errno, errmsg, tag_list } = res.data
        if (errno == '0') {
          this.contentTags = tag_list
          // console.log(this.contentTags)
        } else {
          this.$message({
            message: errmsg,
            type: 'warning',
          })
        }
      })
    },
    // 获取日行程列表
    getDayTripList() {
      this.loading = true
      this.$http
        .get(
          `/traver/get_day_trip_list?p_num=${this.pagenum_system}&p_size=${this.pagesize}&dest=${this.dest}&traver_id=${this.traver_id}&trip_type=${this.trip_type}&trip_mode=${this.trip_mode}&recommend_time=${this.recommend_time}&key_word=${this.searchContentKeyword}`
        )
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            this.page_account = res.data.total
            this.dayTripData = res.data.data
            this.loading = false
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'console.error();',
            })
          }
        })
    },

    //   创建迹点
    creatNewTraverContent() {
      const newpage = this.$router.resolve({
        name: 'creat_day_trip',
      })
      window.open(newpage.href, '_blank')
    },
  },
}
</script>

<style>
.filter-area {
  display: flex;
  justify-content: flex-start;
}
.trip_attritube_style {
  margin-left: 20px;
}
.filter-area-tag {
  margin-top: 20px;
}
.weekend-style-day-trip {
  font-size: 10px;
  color: lightgrey;
  /* background-color: #ff5421; */
  padding: 0 5px;
}
.pagination {
  text-align: right;
  margin-top: 10px;
}
</style>